var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.appUrl),expression:"appUrl"}],staticClass:"store-badge",attrs:{"target":"_blank","href":_vm.appUrl}},[_c('img',{staticClass:"appstore",style:(`width: ${_vm.width}`),attrs:{"alt":_vm.altText,"src":_vm.badgeUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }